import apiClient from './apiClient';

export class AdhocScansService {

    async getAdhocScans(search) {
      const response = await apiClient.get("api/adhocScans/", {
        params: search
      });
      return response.data;
    }

    async getAdhocScan(id) {
        const response = await apiClient.get("api/adhocScans/" + id);
        return response.data;
    }

    // Posts the supplied Excel file to the api
    async createAdhocScan(formData, config = {}) {

        await apiClient.post("api/adhocScans/startScan", formData, config)
        .then(function () {
            console.log("createAdhocScan success");
        })
        .catch(function(error) {
            console.log("createAdhocScan error: " + error);
        });

        apiClient.clearCache('api/catCodes');
        apiClient.clearCache('api/listings');
        apiClient.clearCache('api/snapshots');
    }

    async anyScansInProgress() {
        const response = await apiClient.get("api/adhocScans/anyInProgress/");
        return response.data;
    }

    getLatestResult() {
        console.log("getting latest");
        var url = apiClient.axios.defaults.baseURL + "api/adhocScans/latest";
        window.open(url, '_blank');
    }

    async cancelAdhocScan() {
        const response = await apiClient.post("api/adhocScans/cancelScan");
        return response.data;
    }

    async startScanByCatCode(catCode) {
        const response = await apiClient.post("api/adhocScans/startScanByCatCode/" + encodeURIComponent(catCode));

        apiClient.clearCache('api/catCodes');
        apiClient.clearCache('api/listings');
        apiClient.clearCache('api/snapshots');

        return response.data;
    }
  }